import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { useCreatePlan } from '../hooks/useCreatePlan';
import { PlanForm } from '../components/PlanForm';
import type { CreatePlanDTO } from '../types';

interface PlanCreatePageProps {
  productId?: string;
}

export function PlanCreatePage({ productId }: PlanCreatePageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useCreatePlan();

  const handleSubmit = async (data: CreatePlanDTO) => {
    await mutateAsync(data);
    void navigate({ to: '/dashboard/plans' });
  };

  return (
    <div className="max-w-xl mx-auto space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{t('plans.create')}</h1>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('plans.create')}</CardTitle>
        </CardHeader>
        <CardContent>
          <PlanForm
            mode="create"
            {...(productId ? { productId } : {})}
            onSubmit={handleSubmit as never}
            isSubmitting={isPending}
          />
        </CardContent>
      </Card>
    </div>
  );
}
